import React, { useContext } from "react";
import { ContentSection, Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { OrderDashboardContext } from "../provider/OrderDashboardContext";

interface OrderMaterialSpecificationSectionProps {
    minHeight: number;
}

export const OrderMaterialSpecificationSection: React.VFC<OrderMaterialSpecificationSectionProps> = ({
    minHeight
}: OrderMaterialSpecificationSectionProps) => {
    const { orderDashboardItem, isLoading } = useContext(OrderDashboardContext);

    return (
        <ContentSection
            header="Material specification"
            style={{ minHeight, flex: 1 }}
            isLoading={isLoading}
            testId={"order-material-specification-section"}
        >
            <Grid>
                <GridRow>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Encoding format"
                            testId="order-encodingFormat"
                            value={orderDashboardItem.materialSpecification?.encodingFormat}
                        />
                        <LabeledText
                            label="Aspect ratio"
                            testId="order-aspectRatio"
                            value={orderDashboardItem.materialSpecification?.aspectRatio}
                        />
                        <LabeledText
                            label="Runtime"
                            testId="order-runtime"
                            value={orderDashboardItem.materialSpecification?.runtime}
                        />
                    </GridColumn>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Bit rate"
                            testId="order-bitRate"
                            value={orderDashboardItem.materialSpecification?.bitRate}
                        />
                        <LabeledText
                            label="Resolution"
                            testId="order-resolution"
                            value={orderDashboardItem.materialSpecification?.resolution}
                        />
                        <LabeledText
                            label="Notes"
                            testId="order-notes"
                            nowrap={false}
                            value={orderDashboardItem.notes}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
